"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8451],{

/***/ 68451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ proof_and_badges_enterprise_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js + 1 modules
var side_by_side_text_and_asset = __webpack_require__(25641);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/proof-and-badges-enterprise/components/proofs-section-component.scss.js

var StyledProofsSectionComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1behn490"
})("height:100%;.proofs-container{height:100%;display:flex;flex-direction:column;gap:32px;.proof{background:linear-gradient(rgba(66,66,66,1) 0%,rgba(0,0,0,1) 100%);", function(param) {
    var backgroundImage = param.backgroundImage;
    return backgroundImage ? "background-image: url(".concat(backgroundImage, ")") : "";
}, "      flex:1;padding:40px;border:1px solid #545454;border-radius:12px;}}");

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/proof-and-badges-enterprise/components/proofs-section-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



function ProofsSectionComponent(props) {
    var proofs = props.proofs, backgroundImage = props.backgroundImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProofsSectionComponent, {
        backgroundImage: backgroundImage,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "proofs-container",
            children: proofs === null || proofs === void 0 ? void 0 : proofs.map(function(proof, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "proof",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, _object_spread({}, proof))
                }, index);
            })
        })
    });
}

// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/proof-and-badges-enterprise/components/badges-section-component.scss.js


var StyledBadgesSectionComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1vpd8jj0"
})("height:100%;width:100%;.badges-sections-container{height:100%;display:flex;flex-direction:column;justify-content:space-between;gap:32px;background:linear-gradient(rgba(66,66,66,1) 0%,rgba(0,0,0,1) 100%);border:1px solid #545454;border-radius:12px;padding:40px;.badges-section{.section-header{display:flex;align-items:center;padding-bottom:20px;margin-bottom:20px;border-bottom:1px solid #545454;.icon{width:48px;margin-right:16px;}.section-info{display:flex;flex-direction:column;align-self:center;gap:8px;.title{font-size:18px;}.description{font-size:16px;}}}.badges-container{display:flex;justify-content:center;gap:32px;.badge{width:100px;width:min(calc((100vw / ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, ") * 100),100px);}}}}");

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/proof-and-badges-enterprise/components/badges-section-component.js




function BadgesSectionComponent(props) {
    var badgesSections = props.badgesSections;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBadgesSectionComponent, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "badges-sections-container",
            children: badgesSections === null || badgesSections === void 0 ? void 0 : badgesSections.map(function(badgesSection, index) {
                var _badgesSection_badges;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "badges-section",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "section-header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                                        image: {
                                            src: badgesSection === null || badgesSection === void 0 ? void 0 : badgesSection.icon
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "section-info",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                            className: "title",
                                            text: badgesSection === null || badgesSection === void 0 ? void 0 : badgesSection.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "description",
                                            children: badgesSection === null || badgesSection === void 0 ? void 0 : badgesSection.description
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "badges-container",
                            children: badgesSection === null || badgesSection === void 0 ? void 0 : (_badgesSection_badges = badgesSection.badges) === null || _badgesSection_badges === void 0 ? void 0 : _badgesSection_badges.map(function(badge, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "badge",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
                                        image: {
                                            src: badge === null || badge === void 0 ? void 0 : badge.badgeImage
                                        }
                                    })
                                }, index);
                            })
                        })
                    ]
                }, index);
            })
        })
    });
}

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/proof-and-badges-enterprise/proof-and-badges-enterprise-component.scss.js


var StyledProofAndBadgesEnterpriseComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e7l9muk0"
})("max-width:", "".concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px"), ";margin:auto;.side-by-side-text-and-asset{.side-by-side-content{.full-paragraph-component-wrapper{height:100%;padding:0 32px 0 0;}.image-wrapper.center{height:100%;}}}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.side-by-side-text-and-asset{.side-by-side-content{.full-paragraph-component-wrapper{height:100%;padding:0;}.image-wrapper.center{margin-top:32px;}}}}");

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/proof-and-badges-enterprise/proof-and-badges-enterprise-component.js
function proof_and_badges_enterprise_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function proof_and_badges_enterprise_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            proof_and_badges_enterprise_component_define_property(target, key, source[key]);
        });
    }
    return target;
}





var ProofAndBadgesEnterpriseComponent = function(props) {
    var proofsSection = props.proofsSection, badgesSection = props.badgesSection, sideBySideAdvancedProps = props.sideBySideAdvancedProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProofAndBadgesEnterpriseComponent, {
        className: "proof-and-badges-enterprise-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, proof_and_badges_enterprise_component_object_spread({
            replaceTextComponent: ProofsSectionComponent,
            replaceAssetComponent: BadgesSectionComponent,
            replaceTextComponentProps: proofsSection,
            replaceAssetComponentProps: badgesSection
        }, sideBySideAdvancedProps))
    });
};
/* harmony default export */ var proof_and_badges_enterprise_component = (ProofAndBadgesEnterpriseComponent);


/***/ })

}]);